import { LandingPageSections } from '../LandingPage.types'

const generalLandingPageSections: LandingPageSections[] = [
  {
    type: 'hero',
    id: '1',
    desktopWidth: 'full',
    images: {
      desktop:
        'https://images.babylist.com/image/upload/v1689869400/Desktop_-_Hero_ke10yv.png',
      mobile:
        'https://images.babylist.com/image/upload/v1689869431/Mobile_-_overlay_-_hero_ndltg7.png',
    },
    orientation: 'overlay',
    headerText: 'Your baby is one-of-a-kind. Your registry can be too.',
    callToAction: {
      type: 'link',
      id: '1',
      text: 'Start my registry',
      url: '/registry/new',
    },
  },
  {
    type: 'cards',
    id: '2',
    desktopWidth: 'limited',
    imageShape: 'largeRectangle',
    background: 'white',
    mobileVariant: 'stacked',
    desktopVariant: 'threeColumns',
    headerText: 'One Registry for All Stores',
    subHeaderText: 'Add any item from anywhere',
    cards: [
      {
        type: 'card',
        id: '1',
        headerText:
          'Want to register for all those cute clothes you see on Instagram?',
        subHeaderContent: "We've got you covered.",
        imageUrl:
          'https://images.babylist.com/image/upload/v1690472261/Icon_2_yrluo0.svg',
      },
      {
        type: 'card',
        id: '2',
        headerText: 'Do your gift givers want to always get the best price?',
        subHeaderContent: 'Our price comparisons will be there to help.',
        imageUrl:
          'https://images.babylist.com/image/upload/v1690472241/Icon_1_npatv1.svg',
      },
      {
        type: 'card',
        id: '3',
        headerText: 'Not sure which stroller is best for your family?',
        subHeaderContent: "We're the baby product pros.",
        imageUrl:
          'https://images.babylist.com/image/upload/v1690472190/Icon_oexsd5.svg',
      },
    ],
    callToAction: {
      type: 'link',
      id: '2',
      text: 'Get started',
      url: '/registry/new',
    },
  },
  {
    type: 'feature_highlight',
    id: '3',
    imageUrl:
      'https://images.babylist.com/image/upload/v1694625236/New_Checklist_Screen_Mock_-_Resized_wdedzj.png',
    headerText: "Our checklist guarantees you'll have what you need.",
    description: {
      content: [
        "Add products from any store and we'll check it off as you go!",
      ],
      renderAsListItems: false,
    },
    desktopWidth: 'full',
    layout: 'sideBySide',
    imagePlacement: 'right',
    background: 'mutedEggplant',
    callToAction: {
      type: 'link',
      id: '3',
      text: 'Try it now',
      url: '/registry/new',
    },
    isRectangleImage: true,
  },
  {
    type: 'final_cta',
    id: '4',
    heading: 'Ready to make your <br/> perfect baby registry?',
    callToAction: {
      type: 'link',
      id: '3',
      text: 'Create my Babylist',
      url: '/registry/new',
    },
  },
]

export default generalLandingPageSections
